import React, { useState } from "react";
import { useSelector } from "react-redux";
import { cn } from "../../utils/utils";

type propsType = {
  textAreaProps: React.HTMLProps<HTMLTextAreaElement>;
  label?: string;
  maxLength?: number;
  isRequired?: boolean;
  containerClass?: string;
  textAreaContainerClass?: string;
  textAreaClass?: string;
  labelClass?: string;
};

const TextArea = ({
  textAreaProps,
  label,
  maxLength = 300,
  isRequired = true,
  containerClass,
  textAreaContainerClass,
  textAreaClass,
  labelClass
}: propsType) => {
  const [count, setCount] = useState(
    //@ts-ignore
    textAreaProps.value ? textAreaProps.value.length : 0
  );
  const lang = useSelector((state: any) => state?.user?.lang);

  return (
    <div className={cn("w-full ",containerClass)}>
      <label className={cn("block mb-2 text-sm  text-primary dark:text-white",labelClass)}>
        {label}

        {isRequired && <span className="text-red-500">*</span>}
      </label>
      <div className={cn("relative",textAreaContainerClass)}>
        <textarea
          maxLength={maxLength}
          {...textAreaProps}
          onChange={(e) => {
            setCount(e.target.value.length);
            // @ts-ignore
            textAreaProps.onChange(e);
          }}
          className={cn("bg-white border resize-y  text-sm  customScroll dark:bg-primaryLight dark:text-white   text-[#747474]  border-gray-300 rounded-lg focus:outline-primary focus:ring-primary focus:border-primary block w-full p-2.5 placeholder-gray-400 py-3.5  ",textAreaClass)}
        />
        <p
          className={`absolute bottom-0 ${
            lang == "ar" ? "left-2" : "right-2"
          } text-sm    text-[#747474]`}
        >
          {count}/{maxLength}
        </p>
      </div>
    </div>
  );
};

export default TextArea;
